module.exports = __webpack_public_path__ + "static/media/entertainment.527d4c31.svg";